<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="补货申请"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="api.list"
     
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          <el-form-item label="商品名称">
            <el-input v-model="params.GoodsName" placeholder="请输入商品名称" clearable />
          </el-form-item>

           <el-form-item label="联系号码">
            <el-input v-model="params.ContactPhone" placeholder="请输入联系号码" clearable />
          </el-form-item>
        
           <el-form-item label="用户姓名">
            <el-input v-model="params.PersonName" placeholder="请输入用户姓名" clearable />
          </el-form-item>

           <el-form-item label="状态">
            <el-select size="mini" v-model="params.State" placeholder="请选择状态" clearable>
                <el-option label="待阅" :value="1"></el-option>
                <el-option label="已阅" :value="2"></el-option>
             </el-select>
          </el-form-item>    
         
        </template>
        <template slot="table">
          <el-table-column prop="GoodsName" label="商品名称" />
          <el-table-column prop="ContactPhone" label="联系号码" />
           <el-table-column prop="PersonName" label="用户姓名" />
           <el-table-column prop="ApplyTime" label="申购时间"  />
        
           <el-table-column prop="StoreName" label="所属商家" v-if="$permission.isStore()==false"/> 
            <el-table-column prop="State" width="80px" label="状态" align="center">
            <template slot-scope="{row}">
              <el-tag size="mini" type="danger" v-if="row.State == 1">待阅</el-tag>
              <el-tag size="mini" type="success" v-else>已阅</el-tag>
            </template>
          </el-table-column>
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
        api: require("@/api/sale/apply").default,
        params: {
          GoodsName: "",
          ContactPhone: "",
          PersonName: "",
          State: null,
        },
      };
    },
   mounted() {
     //这段就是从工作台获取点击后进入的参数，去过滤对应状态的数据。
    if (this.$route.query.State == 1) {
      this.params.State = 1;
      this.query(this.params);
    } 
  },
    methods: {
  
      delRange(ids) {
        this.api.delete({ ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
  </script>